import * as React from 'react';
import { SVGProps } from 'react';

const SvgX = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.364 7.05 16.95 5.636 12 10.586l-4.95-4.95L5.636 7.05l4.95 4.95-4.949 4.949 1.414 1.414L12 13.414l4.949 4.949 1.414-1.414L13.414 12l4.95-4.95z" />
  </svg>
);

export default SvgX;
